import { render, staticRenderFns } from "./WarehouseProductDetails.vue?vue&type=template&id=589a17a0&"
import script from "./WarehouseProductDetails.vue?vue&type=script&lang=js&"
export * from "./WarehouseProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports